import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=6cf46be0&scoped=true&"
import script from "./ProjectAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&id=6cf46be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf46be0",
  null
  
)

export default component.exports